function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.6406 19.3744H3.35938C2.36859 19.3744 1.5625 18.5683 1.5625 17.5775V8.1236C1.5625 7.77844 1.8423 7.4986 2.1875 7.4986C2.5327 7.4986 2.8125 7.77844 2.8125 8.1236V17.5775C2.8125 17.8791 3.05781 18.1244 3.35938 18.1244H16.6406C16.9422 18.1244 17.1875 17.8791 17.1875 17.5775V8.1236C17.1875 7.77844 17.4673 7.4986 17.8125 7.4986C18.1577 7.4986 18.4375 7.77844 18.4375 8.1236V17.5775C18.4375 18.5683 17.6314 19.3744 16.6406 19.3744Z",
  fill: "current"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.375 10.3109C19.215 10.3109 19.0551 10.2499 18.9331 10.1278L11.1601 2.35488C10.5204 1.71519 9.4796 1.71519 8.83991 2.35488L1.06694 10.1278C0.822881 10.3719 0.427139 10.3719 0.183076 10.1278C-0.0610254 9.88378 -0.0610254 9.48804 0.183076 9.24398L7.95605 1.47097C9.08308 0.343944 10.9169 0.343944 12.0439 1.47097L19.8169 9.24394C20.061 9.48804 20.061 9.88374 19.8169 10.1278C19.6949 10.2499 19.535 10.3109 19.375 10.3109Z",
  fill: "current"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12.5 19.3744H7.5C7.1548 19.3744 6.875 19.0945 6.875 18.7494V13.2025C6.875 12.1255 7.75117 11.2494 8.82812 11.2494H11.1719C12.2488 11.2494 13.125 12.1255 13.125 13.2025V18.7494C13.125 19.0945 12.8452 19.3744 12.5 19.3744ZM8.125 18.1244H11.875V13.2025C11.875 12.8148 11.5596 12.4994 11.1719 12.4994H8.82812C8.44043 12.4994 8.125 12.8148 8.125 13.2025V18.1244Z",
  fill: "current"
});

var SvgDashboard = function SvgDashboard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDashboard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Dashboard.53ae6a16.svg";
export { ForwardRef as ReactComponent };